import { render, staticRenderFns } from "./OdocTrainNumberInput.vue?vue&type=template&id=42612fed"
import script from "./OdocTrainNumberInput.vue?vue&type=script&lang=js"
export * from "./OdocTrainNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports